export class ClientSearchModel {
    client_no: string
    status: string
    patient_no: string
    last_name: string
    phone: string
    patient_name: string
    first_name: string
    tag_no: string
    location_id: number
    sublocation_id: number
    page_number: number
    type: TypeClientSearch

    constructor(
        client_no: string,
        status: string,
        patient_no: string,
        last_name: string,
        phone: string,
        patient_name: string,
        first_name: string,
        tag_no: string,
        location_id: number,
        sublocation_id: number,
        page_number: number,
        type: TypeClientSearch
    ) {
        this.client_no = client_no
        this.status = status
        this.patient_no = patient_no
        this.last_name = last_name
        this.phone = phone
        this.patient_name = patient_name
        this.first_name = first_name
        this.tag_no = tag_no
        this.location_id = location_id
        this.sublocation_id = sublocation_id
        this.page_number = page_number
        this.type = type
    }
}

export class ClientSearchResultsModel {
    row_num: number;
    client_no: string;
    pet_no?: number;
    client_name: string;
    second_contact: string;
    phone_number: string;
    client_notes: string;
    active: string;
    last_invoice_date: any;

    constructor(
        _row_num: number,
        _client_no: string,
        _client_name: string,
        _second_contact: string,
        _phone_number: string,
        _client_notes: string,
        _active: string,
        _last_invoice_date: any
    ) {
        this.row_num = _row_num;
        this.client_no = _client_no;
        this.client_name = _client_name;
        this.second_contact = _second_contact;
        this.phone_number = _phone_number;
        this.client_notes = _client_notes;
        this.active = _active;
        this.last_invoice_date = _last_invoice_date;
    }
}

export enum TypeClientSearch {
    SELECT,
    DETAIL,
    CLIENT,
    RETURN
} 